import { render, staticRenderFns } from "./rmsStrategy.vue?vue&type=template&id=e40ec98c"
import script from "./rmsStrategy.vue?vue&type=script&lang=js"
export * from "./rmsStrategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports